module.exports = __webpack_public_path__ + "static/images/containers/MainMenu/images/mainmenu-item-rewards-32.543c448b.png";


//////////////////
// WEBPACK FOOTER
// ./containers/MainMenu/images/mainmenu-item-rewards-32.png
// module id = 3201
// module chunks = 11